import { IBaseEventFact, IPaymentPlanScopedFact } from './common';
import {
  PaymentPlanAction,
  PaymentPlanStatus,
} from '@principle-theorem/principle-core/interfaces';

export interface IPaymentPlanEventFact
  extends IPaymentPlanScopedFact,
    IBaseEventFact<PaymentPlanAction, PaymentPlanStatus> {}
